import { Deserializable } from "@app/interfaces/deserializable";


export class UserCredentials {

    public userName: string;
    public password: string;

    constructor (userName: string, password: string) {
        this.userName = userName;
        this.password = password;
    }

    deserialize(input: any) {
        Object.assign(this, input);
        return this;
    }
}
